Twig.extendFilter("unescape", (value, args ) => {
	return $('<textarea />').html(value).text();
});

Twig.extendFunction('setting', (value) => {
	return NOW.settings[value] || '';
});
